import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CallReportsPage } from '@/components/calls/report/CallReportsPage';
import { parseReportSearch } from '@/components/calls/report/reportRange';
import { Flush } from '@/contexts/fullbleed';

/**
 * Calls → Reports — its own page, not a tab on the queue.
 *
 * The trailing-underscore segment (`calllogs_.reports`) opts out of nesting
 * under the `calllogs` route, so this renders as a full page rather than
 * inside the queue's panel.
 */

export const Route = createFileRoute('/_dashboard/dashboard/calllogs_/reports')({
  validateSearch: parseReportSearch,
  component: CallReportsRoute,
});

function CallReportsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();

  return (
    <>
      <Flush />
      <CallReportsPage
        search={search}
        onSearchChange={(next) =>
          void navigate({
            to: '/dashboard/calllogs/reports',
            search: next as never,
            replace: true,
          })
        }
        onBack={() => void navigate({ to: '/dashboard/calllogs' })}
        onOpenCallLog={(drill) =>
          void navigate({
            to: '/dashboard/calllogs',
            search: (drill.view === 'action-needed'
              ? {}
              : { view: 'calls', from: drill.from, to: drill.to, direction: drill.direction, status: drill.status }) as never,
          })
        }
      />
    </>
  );
}
